import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-privacy--is-public", -1),
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16",
        fill: "#FFF"
      }),
      _createElementVNode("path", {
        d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1.37A6.625 6.625 0 1 0 8 1.38a6.625 6.625 0 0 0 0 13.25zM6.83 5.102l.027-.432.551-.216h1.187l.358-.324.22-.622.607-.324.8-.567.017-.143a6.224 6.224 0 0 0-2.665-.613 6.223 6.223 0 0 0-4.354 1.761l-.058.21.028.379.468.352.167.35.027.486-.027.568.413.027.442.163s.358.107.468.215c.11.109.717.487.8.621.082.136.495.136.495.136.332-.27 0-.648 0-.648l-.137-.324-.11-.324.056-.38.22-.35zm6.148 4.243l-.359-.433h-.523l-.468-.162-.359-.567-.579-.46-.249-.513h-.606L8.98 7.05l-.248.08-.359.405-.302.217-.139 1.026v1.216c0 .108.165.324.304.54.137.216.22.46.33.595.111.135.249.135.442.215.193.081.386.27.47.407.082.134.136.648.136.648l.111.89v.387c.313-.093.616-.203.906-.343l.39-.286.661-.406.23-.135a6.03 6.03 0 0 0 1.313-1.518l.057-.319v-.54l-.083-.325-.22-.458z",
        fill: "#81BB0F"
      })
    ], -1)
  ]))]))
}
export default { render: render }